const Index = () => import(/* webpackChunkName: "proj" */ './Index');
const Manage = () => import(/* webpackChunkName: "proj" */ './Manage');
const PersonalReview = () => import(/* webpackChunkName: "proj" */ './PersonalReview');
const ReviewTemplate = () => import(/* webpackChunkName: "manager" */ './Indicators/Index');
const ExpertReview = () => import(/* webpackChunkName: "proj" */ './ExpertReview');
const ReviewMark = () => import(/* webpackChunkName: "proj" */ './ReviewMark');
const PreReview = () => import(/* webpackChunkName: "manager" */ './PreReview/PreReviewIndex');
export default {
    routes: [
        {
            path: '/proj/review/index',
            name: 'proj_review_index',
            component: Index
        },
        {
            path: '/proj/review/manage/:dbid',
            name: 'proj_review_manage',
            component: Manage
        },
        {
            path: '/review/personal',
            name: 'porj_review_personal',
            component: PersonalReview
        },
        {
            path: '/review/template',
            name: 'porj_review_template',
            component: ReviewTemplate
        },
        {
            path: '/review/expert',
            name: 'expert',
            component: ExpertReview
        },
        {
            path: '/proj/review/mark/:dbid',
            name: 'review_mark',
            component: ReviewMark
        },
        {
            path: '/proj/review/prereview',
            name: 'prereviewindex',
            component: PreReview
        },
    ]
}
